/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The SetupIntentsSetupIntent model module.
 * @module model/SetupIntentsSetupIntent
 * @version v0.3
 */
export default class SetupIntentsSetupIntent {
  /**
   * Constructs a new <code>SetupIntentsSetupIntent</code>.
   * @alias module:model/SetupIntentsSetupIntent
   * @class
   * @param patientId {String} ID of the patient you want to setup a payment setup intent for for
   */
  constructor(patientId) {
    this.patientId = patientId;
  }

  /**
   * Constructs a <code>SetupIntentsSetupIntent</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SetupIntentsSetupIntent} obj Optional instance to populate.
   * @return {module:model/SetupIntentsSetupIntent} The populated <code>SetupIntentsSetupIntent</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SetupIntentsSetupIntent();
      if (data.hasOwnProperty('patient_id'))
        obj.patientId = ApiClient.convertToType(data['patient_id'], 'String');
    }
    return obj;
  }
}

/**
 * ID of the patient you want to setup a payment setup intent for for
 * @member {String} patientId
 */
SetupIntentsSetupIntent.prototype.patientId = undefined;

